import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ghostConsumersTrendSlice = createApi({
  reducerPath: "ghostConsumersTrend",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["ghostConsumersTrend"],
  endpoints: (build) => ({
    getGhostConsumersTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/ghost_consumer/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["ghostConsumersTrend"],
    }),
  }),
});

export const { useGetGhostConsumersTrendQuery } = ghostConsumersTrendSlice;

export const useQueryStateGhostConsumersTrend = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data[0],
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
